import { useNavigate } from 'react-router-dom';
import { ContractsListPage as SharedContractsListPage } from '@/features/contracts/components/ContractsListPage';
import { usePermissions } from '../../../hooks/auth/usePermissions';

/**
 * Page de liste des contrats (outil-pro)
 * Wrapper léger autour du composant partagé qui active l'onglet brouillons
 * et la navigation vers le détail d'un contrat.
 */
export function ContractsListPage() {
  const { can } = usePermissions();
  const navigate = useNavigate();

  return (
    <SharedContractsListPage
      embedded
      showDraftsTab
      onRowClick={(contract) => navigate(`/contracts/${contract.id}`)}
      onDraftResume={(draft) => navigate(`/contracts/create?draftId=${draft.uuid}`)}
      headerActions={
        can('contract.create') ? (
          <button
            onClick={() => navigate('/contracts/create')}
            className="tw-px-4 tw-py-2 tw-bg-affinicar-primary tw-text-white tw-rounded-lg hover:tw-bg-affinicar-secondary tw-transition tw-font-medium"
          >
            + Nouveau contrat
          </button>
        ) : null
      }
    />
  );
}
